import { Prestation, PrestationJson } from '@gi/models/prestation';
import { DateHelper } from '@helpers/date.helper';
import { HttpHelper } from '@helpers/http.helper';
import { GIFile, GIFileJson } from '@models/gi-file';
import {
  ModelOfferContractAnnexModel,
  ModelOfferContractAnnexModelJson
} from '@models/model-offer-contract-annex-model';
import { Offer, OfferJson } from '@models/offer';

export interface ModelOfferJson extends OfferJson {
  offer_model_prestations: Partial<PrestationJson>[];
  offer_model_files: Partial<GIFileJson>[];
  annexes: Partial<ModelOfferContractAnnexModelJson>[];
  archived_at: string;
}

export class ModelOffer extends Offer {
  constructor(
    id?: number,
    tag?: string,
    label?: string,
    public prestations?: Prestation[],
    public files?: GIFile[],
    public annexes?: ModelOfferContractAnnexModel[],
    public archivedAt?: Date
  ) {
    super(id, tag, label);
  }

  static fromJson(json: Partial<ModelOfferJson>): ModelOffer {
    return new ModelOffer(
      json.id,
      json.tag,
      json.label,
      json.offer_model_prestations
        ? json.offer_model_prestations.map((prestationJson: PrestationJson) => Prestation.fromJson(prestationJson))
        : [],
      json.offer_model_files ? json.offer_model_files.map((fileJson: GIFileJson) => GIFile.fromJson(fileJson)) : [],
      json.annexes
        ? json.annexes.map((annexJson: ModelOfferContractAnnexModel) =>
            ModelOfferContractAnnexModel.fromJson(annexJson)
          )
        : [],
      json.archived_at ? DateHelper.fromUtc(json.archived_at) : null
    );
  }

  static toJson(model: ModelOffer): Omit<ModelOfferJson, 'offer_model_files' | 'annexes' | 'archived_at'> {
    return {
      id: HttpHelper.toJsonProperty(model.id),
      tag: HttpHelper.toJsonProperty(model.tag),
      label: HttpHelper.toJsonProperty(model.label),
      offer_model_prestations: model.prestations?.length
        ? model.prestations.map(prestation => Prestation.toJson(prestation))
        : []
    };
  }
}
